import { render } from "./AcademyBlock.vue?vue&type=template&id=bbbd3bd8&scoped=true"
import script from "./AcademyBlock.vue?vue&type=script&lang=js"
export * from "./AcademyBlock.vue?vue&type=script&lang=js"

import "./AcademyBlock.vue?vue&type=style&index=0&id=bbbd3bd8&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bbbd3bd8"]])

export default __exports__